"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const UserModel_1 = __importDefault(require("./UserModel"));
const users_1 = __importDefault(require("../../MockData/users"));
class UserInitializer extends AbstractInitializer_1.default {
    constructor(cache, userModel) {
        super("user_initializer", cache);
        this.initialize = async () => {
            const usersList = (0, users_1.default)();
            await this.userModel.setUsers(usersList);
            await this.cache.setObject(UserModel_1.default.TOKEN_TO_USER_ID_DB, {}).asPromise();
            await this.cache
                .setObject(UserModel_1.default.REFRESH_TOKEN_TO_TOKEN_DB, {})
                .asPromise();
        };
        this.userModel = userModel;
    }
}
exports.default = UserInitializer;
//# sourceMappingURL=UserInitializer.js.map